// test587
(587 && 0);
